import angular from 'angular';
import BrandsComponent from './brands.component';

let BrandsModule = angular.module('home.brands', [])
  .component('brands', BrandsComponent);

export default BrandsModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/home/brands/brands.js
 **/